const menuList = [
    {
        label: 'default',
        items: [
            {
                label: 'dashboard',
                icon: 'ri-dashboard-line ri-lg',
                to: '/',
                action: 'view',
                resource: 'dashboard'
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'App Analytics',
                icon: 'ri-bar-chart-box-line ri-lg',
                items: [
                    {
                        label: 'Amplitude',
                        icon: 'ri-bar-chart-box-line ri-lg',
                        action: 'view',
                        resource: 'amplitude_dashboard',
                        to: '/amplitude-dashboard'
                    }
                ]
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'Administration',
                icon: 'ri-book-line ri-lg',
                action: 'view',
                resource: 'users',
                items: [
                    {
                        label: 'user.menu',
                        icon: 'ri-user-3-line ri-lg',
                        action: 'view',
                        resource: 'users',
                        to: '/user'
                    },
                    {
                        label: 'Referrals',
                        icon: 'ri-group-line ri-lg',
                        action: 'view',
                        resource: 'referrals',
                        to: '/referrals'
                    },
                    {
                        label: 'Family Member',
                        icon: 'ri-group-line ri-lg',
                        action: 'view',
                        resource: 'familymembers',
                        to: '/family-members'
                    },
                    {
                        label: 'Registration',
                        icon: 'ri-user-shared-line ri-lg',
                        action: 'view',
                        resource: 'registration-requests',
                        to: '/registration-request'
                    },
                    {
                        label: 'Employee Records',
                        icon: 'ri-team-line ri-lg',
                        action: 'view',
                        resource: 'employee_records',
                        to: '/employee-record'
                    },
                    {
                        label: 'Audit Log',
                        icon: 'ri-file-list-3-line ri-lg',
                        action: 'view',
                        resource: 'audit-logs',
                        to: '/audit-log'
                    }
                ]
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'Appointment Slot',
                icon: 'ri-coupon-line ri-lg',
                action: 'view',
                resource: 'doctor-timeslots',
                items: [
                    {
                        label: 'timeslot.timeslot_menu',
                        icon: 'ri-timer-line ri-lg',
                        action: 'view',
                        resource: 'doctor-timeslots',
                        to: '/doctor-timeslot'
                    },
                    {
                        label: 'doctor.attendance',
                        icon: 'ri-suitcase-line ri-lg',
                        action: 'view',
                        resource: 'doctor-attendances',
                        to: '/doctor-attendance'
                    }
                ]
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'appointment.menu',
                icon: 'ri-todo-line ri-lg',
                action: 'view_current',
                resource: 'appointments',
                items: [
                    {
                        label: 'Make Appointment',
                        to: '/appointment/new',
                        icon: 'ri-draft-line ri-lg',
                        action: 'make_appointment',
                        resource: 'appointments'
                    },
                    {
                        label: 'appointment.current_appointment',
                        icon: 'ri-stack-line ri-lg', //remix icon
                        to: '/appointment/current',
                        action: 'view_current',
                        resource: 'appointments'
                    },
                    {
                        label: 'appointment.appointment_history',
                        icon: 'ri-file-history-line ri-lg', //remix icon
                        to: '/appointment/history',
                        action: 'view_history',
                        resource: 'appointments'
                    },
                    {
                        label: 'Refund Appointment',
                        icon: 'ri-refund-2-line ri-lg', //remix icon
                        to: '/appointment/refund',
                        action: 'view_refund',
                        resource: 'appointments'
                    },
                    {
                        label: 'Home Care',
                        icon: 'ri-home-heart-line ri-lg',
                        action: 'view',
                        resource: 'home-care',
                        to: '/home-care'
                    }
                ]
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'Ads',
                icon: 'ri-advertisement-line ri-lg',
                action: 'view',
                resource: 'ads',
                to: '/ads'
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'Coupons',
                icon: 'ri-coupon-line ri-lg',
                action: 'view',
                resource: 'coupons',
                items: [
                    {
                        label: 'Coupons Generate',
                        icon: 'ri-coupon-3-line ri-lg',
                        action: 'view',
                        resource: 'coupons',
                        to: '/coupon'
                    },
                    {
                        label: 'Welcome Gift Coupons',
                        icon: 'ri-coupon-3-line ri-lg',
                        action: 'view_gift',
                        resource: 'coupons',
                        to: '/couponGift'
                    },
                    {
                        label: 'Coupons Redemption',
                        icon: 'ri-coupon-2-line ri-lg',
                        action: 'view_redeemed',
                        resource: 'coupons',
                        to: '/coupon-redemption'
                    }
                ]
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'Loyalty',
                icon: 'ri-vip-crown-line ri-lg',
                action: 'view',
                resource: 'earn-transactions',
                items: [
                    {
                        label: 'Dashboard',
                        icon: 'ri-dashboard-line ri-lg',
                        action: 'view',
                        resource: 'loyalty_dashboard',
                        to: '/loyalty-dashboard'
                    },
                    {
                        label: 'Earn Transaction',
                        icon: 'ri-exchange-dollar-line ri-lg',
                        action: 'view',
                        resource: 'earn-transactions',
                        to: '/earn-transaction'
                    },
                    {
                        label: 'Loyalty Accounts',
                        icon: 'ri-user-star-line ri-lg',
                        action: 'view',
                        resource: 'loyalty-accounts',
                        to: '/loyalty-account'
                    }
                ]
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'Chat Channel',
                icon: 'ri-wechat-line ri-lg',
                action: 'view',
                resource: 'chat_channel',
                items: [
                    {
                        label: 'Chat Room',
                        icon: 'ri-kakao-talk-line ri-lg',
                        to: '/chatroom',
                        action: 'view',
                        resource: 'chat_channel'
                    },
                    {
                        label: 'Chat Subscriptions',
                        icon: 'ri-chat-check-line ri-lg',
                        to: '/chat-subscriptions',
                        action: 'view',
                        resource: 'chat_channel_transactionns'
                    }
                ]
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'Doctor/Medical Staff',
                icon: 'ri-stethoscope-line ri-lg',
                action: 'view',
                resource: 'doctors',
                to: '/doctor'
            }
        ]
    },

    // {
    //     label: 'default',
    //     items: [
    //         {
    //             label: 'content.menu',
    //             icon: 'ri-book-line ri-lg',
    //             action: 'view',
    //             resource: 'content',
    //             to: '/content'
    //         }
    //     ]
    // },

    {
        label: 'default',
        items: [
            {
                label: 'Health Article',
                icon: 'ri-book-line ri-lg',
                action: 'view',
                resource: 'health-article',
                to: '/health-article'
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'Notification',
                icon: 'ri-notification-line ri-lg',
                action: 'view',
                resource: 'custom-notification',
                to: '/notification'
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'Package',
                icon: 'ri-todo-line ri-lg',
                action: 'view',
                resource: 'packages',
                items: [
                    {
                        label: 'Package list',
                        icon: 'ri-archive-line ri-lg',
                        action: 'view',
                        resource: 'packages',
                        to: '/package'
                    },
                    {
                        label: 'Package Group',
                        icon: 'ri-folders-line ri-lg',
                        action: 'view',
                        resource: 'package-groups',
                        to: '/package-group'
                    },
                    {
                        label: 'Public sale',
                        icon: 'ri-team-line ri-lg',
                        to: '/package-sale/public',
                        action: 'view',
                        resource: 'public-package-sale'
                    },
                    {
                        label: 'Corporate sale',
                        icon: 'ri-organization-chart ri-lg',
                        to: '/package-sale/corporate',
                        action: 'view',
                        resource: 'corporate-package-sale'
                    },
                    {
                        label: 'Website package sale',
                        icon: 'ri-organization-chart ri-lg',
                        to: '/package-sale/web',
                        action: 'view',
                        resource: 'public-package-sale'
                    },
                    {
                        label: 'Usage',
                        icon: 'ri-survey-line ri-lg',
                        action: 'view',
                        resource: 'package-usage',
                        to: '/package/usage'
                    },
                    {
                        label: 'Gift',
                        icon: 'ri-gift-2-line ri-lg',
                        action: 'view_gift',
                        resource: 'packages',
                        to: '/package-gifts'
                    }
                ]
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'Promotion Center',
                icon: 'ri-hand-coin-line ri-lg',
                action: 'view',
                resource: 'promotion-center',
                to: '/promotion-center'
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'MCU Booking Management',
                icon: 'ri-calendar-check-line ri-lg',
                action: 'view',
                resource: 'bookings',
                items: [
                    {
                        label: 'Dashboard',
                        icon: 'ri-dashboard-2-line ri-lg',
                        action: 'view',
                        resource: 'mcu_dashboard',
                        to: '/mcu-dashboard'
                    },
                    {
                        label: 'TAT Dashboard',
                        icon: 'ri-timer-line ri-lg',
                        action: 'view',
                        resource: 'tat-dashboard',
                        to: '/mcu-tat-dashboard'
                    },
                    {
                        label: 'Capacity',
                        icon: 'ri-bar-chart-box-line ri-lg',
                        action: 'view',
                        resource: 'capacities',
                        to: '/capacity'
                    },
                    {
                        label: 'Booking',
                        icon: 'ri-dashboard-line ri-lg',
                        action: 'view',
                        resource: 'bookings',
                        to: '/mcu-booking'
                    },
                    {
                        label: 'Booking Cancel',
                        icon: 'ri-delete-bin-line ri-lg',
                        action: 'view',
                        resource: 'booking-cancels',
                        to: '/booking_cancel'
                    },
                    {
                        label: 'MCU Day Check-in',
                        icon: 'ri-user-follow-line ri-lg',
                        action: 'view',
                        resource: 'bookings',
                        to: '/mcu-checkin'
                    },
                    {
                        label: 'MCU SLA Setup',
                        icon: 'ri-time-line ri-lg',
                        action: 'view',
                        resource: 'sla-setups',
                        to: '/sla-setup'
                    },
                    {
                        label: 'MCU TAT Details',
                        icon: 'ri-hourglass-line ri-lg',
                        action: 'view',
                        resource: 'tat-details',
                        to: '/mcu-tat-detail'
                    }
                    // ,
                    // {
                    //     label: 'Import Data',
                    //     icon: 'ri-dashboard-line ri-lg',
                    //     action: 'view',
                    //     resource: 'capacities',
                    //     to: '/mcu-import-data'
                    // }
                ]
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'Retail Sales',
                icon: 'ri-shopping-bag-3-line ri-lg',
                action: 'view',
                resource: 'retail-sales',
                to: '/retail_sale'
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'patient.menu',
                icon: 'ri-team-line ri-lg',
                action: 'view',
                resource: 'patients',
                to: '/patient'
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'Pre DM',
                icon: 'ri-user-heart-line ri-lg',
                action: 'view',
                resource: 'pre-dm',
                items: [
                    {
                        label: 'Appointment Current',
                        icon: 'ri-stack-line ri-lg',
                        action: 'view',
                        resource: 'pre-dm-appointment-current',
                        to: '/pre-dm/appointment/current'
                    },
                    {
                        label: 'Appointment History',
                        icon: 'ri-file-history-line ri-lg',
                        action: 'view',
                        resource: 'pre-dm-appointment-history',
                        to: '/pre-dm/appointment/history'
                    },
                    {
                        label: 'Users',
                        icon: 'ri-team-line ri-lg',
                        action: 'view',
                        resource: 'pre-dm-users',
                        to: '/pre-dm/users'
                    }
                ]
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'Guests',
                icon: 'ri-team-line ri-lg',
                action: 'view',
                resource: 'guest-patients',
                to: '/guest-patient'
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'Pharmacies',
                icon: 'ri-medicine-bottle-line ri-lg',
                action: 'view',
                resource: 'pharmacies',
                to: '/pharmacy'
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'Inbound Referrals',
                icon: 'ri-share-forward-line ri-lg',
                action: 'view',
                resource: 'inbound-referrals',
                to: '/inbound_referrals'
            }
        ]
    },

    {
        label: 'default',
        items: [
            {
                label: 'Set Up',
                icon: 'ri-organization-chart ri-lg',
                action: 'view',
                resource: 'corporates',
                items: [
                    {
                        label: 'Corporate',
                        icon: 'ri-organization-chart ri-lg',
                        action: 'view',
                        resource: 'corporates',
                        to: '/corporate'
                    },
                    {
                        label: 'Services',
                        icon: 'ri-service-line ri-lg',
                        action: 'view',
                        resource: 'services',
                        to: '/service'
                    },
                    {
                        label: 'facility.menu',
                        icon: 'ri-hospital-line ri-lg',
                        action: 'view',
                        resource: 'facilities',
                        to: '/facility'
                    },
                    {
                        label: 'symptom.menu',
                        icon: 'ri-eye-line ri-lg',
                        action: 'view',
                        resource: 'symptoms',
                        to: '/symptom'
                    },
                    {
                        label: 'specialities.menu',
                        icon: 'ri-book-2-line ri-lg',
                        action: 'view',
                        resource: 'specialities',
                        to: '/speciality'
                    },
                    {
                        label: 'category.menu',
                        icon: 'ri-function-line ri-lg',
                        action: 'view',
                        resource: 'categories',
                        to: '/category'
                    },
                    {
                        label: 'Retail',
                        icon: 'ri-store-2-line ri-lg',
                        action: 'view',
                        resource: 'retails',
                        to: '/retail'
                    },
                    {
                        label: 'product.menu',
                        icon: 'ri-box-3-line ri-lg',
                        action: 'view',
                        resource: 'products',
                        to: '/product'
                    },
                    {
                        label: 'Township',
                        icon: 'ri-truck-line ri-lg',
                        action: 'view',
                        resource: 'township-setup',
                        to: '/township-setup'
                    },
                    {
                        label: 'Hospital Service',
                        icon: 'ri-hospital-line ri-lg',
                        action: 'view',
                        resource: 'hospital-services',
                        to: '/hospital-service'
                    },
                    {
                        label: 'Home Care Township',
                        icon: 'ri-map-pin-line ri-lg',
                        action: 'view',
                        resource: 'home-care-townships',
                        to: '/home-care-townships'
                    },
                    {
                        label: 'Referral Setup',
                        icon: 'ri-user-settings-line ri-lg',
                        action: 'view',
                        resource: 'referral-setups',
                        to: '/referral-setup'
                    }
                ]
            }
        ]
    },
    {
        label: 'default',
        items: [
            {
                label: 'chat.menu',
                icon: 'ri-customer-service-2-line ri-lg',
                action: 'view',
                resource: 'doctor-chat',
                to: '/doctor-chat'
            }
        ]
    },
    {
        label: 'default',
        items: [
            {
                label: 'setting.menu',
                icon: 'ri-settings-2-line ri-lg',
                action: 'view',
                resource: 'settings',
                // to: '/setting'
                items: [
                    {
                        // label: 'Mobile Setting',
                        label: 'Portal',
                        icon: 'ri-settings-2-line ri-lg',
                        action: 'view',
                        resource: 'settings',
                        to: '/setting'
                    },
                    {
                        label: 'Mobile',
                        icon: 'ri-settings-2-line ri-lg',
                        action: 'view',
                        resource: 'settings',
                        to: '/mobile-setting'
                    },
                    {
                        label: 'Force Update',
                        icon: 'ri-smartphone-line ri-lg',
                        action: 'view',
                        resource: 'force_update',
                        to: '/force-update'
                    },
                    {
                        label: 'role.menu',
                        icon: 'ri-shield-user-line ri-lg',
                        action: 'manage',
                        resource: 'roles-and-permissions',
                        to: '/roles-and-permission'
                    }
                ]
            }
        ]
    }
]

export default menuList
